import apiClient from './apiClient';

/**
 * Map API plan to frontend shape. id = slug if present, else _id (for matching user.subscriptionPlan).
 */
const normalizeBillingCycle = (p) => {
  const fromApi = String(
    p?.billingCycle ?? p?.planType ?? p?.type ?? ''
  ).trim().toLowerCase();
  if (fromApi === 'annually' || fromApi === 'annual' || fromApi === 'yearly') return 'annually';
  if (fromApi === 'monthly' || fromApi === 'month') return 'monthly';
  const text = String(p?.price ?? '').toLowerCase();
  if (text.includes('/ year') || text.includes('/year') || text.includes('annually') || text.includes('annual')) {
    return 'annually';
  }
  return 'monthly';
};

export const mapPlanFromApi = (p) => ({
  id: (p.slug && p.slug.trim()) ? p.slug.trim() : p._id,
  _id: p._id,
  name: p.name ?? '',
  price: p.price ?? '',
  billingCycle: normalizeBillingCycle(p),
  tag: p.tag ?? '',
  description: p.description ?? '',
  features: Array.isArray(p.features) ? p.features : [],
  sortOrder: p.sortOrder ?? 0,
  slug: p.slug ?? '',
  freeAccessCourseIds: Array.isArray(p.freeAccessCourses)
    ? p.freeAccessCourses.map((x) => (x?._id ?? x).toString())
    : [],
  isAllAccess: !!p.isAllAccess,
});

export const getSubscriptionPlans = async () => {
  const { data } = await apiClient.get('/api/subscription-plans');
  if (!Array.isArray(data)) return [];
  return data.map(mapPlanFromApi);
};

export const createSubscriptionPlan = async (payload) => {
  const { data } = await apiClient.post('/api/subscription-plans', payload);
  return mapPlanFromApi(data);
};

export const updateSubscriptionPlan = async (id, payload) => {
  const { data } = await apiClient.put(`/api/subscription-plans/${id}`, payload);
  return mapPlanFromApi(data);
};

export const deleteSubscriptionPlan = async (id) => {
  await apiClient.delete(`/api/subscription-plans/${id}`);
};
